"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function renderText(text) {
    var regex = text.match(
    // eslint-disable-next-line
    /(https?|file):\/\/[a-zA-Z0-9\/:%#&~=_!'\$\?\(\)\.\+\*\-]+|(^|\n)\\\\[^<>{}"`|\^\[\]\r\n]+/g);
    if (!regex) {
        return text;
    }
    var results = [text];
    regex.forEach(function (url, idx) {
        if (url[0] === '\n')
            url = url.substring(1);
        var href = url;
        if (/^\\\\/.test(url)) {
            href = 'file:' + encodeURI(url.replace(/\\/g, '/'));
        }
        var target = results.pop();
        if (target && typeof target === 'string') {
            var items = target.split(url);
            results = __spreadArrays(results, [
                items[0],
                react_1.default.createElement("a", { href: href, key: idx, target: "_blank", rel: "noopener" }, url),
                items.slice(1).join(url)
            ]).filter(function (e) { return !!e; });
        }
    });
    return results;
}
exports.renderText = renderText;
//# sourceMappingURL=renderText.js.map